"use client";

import React from "react";
import { ArrowRight, Activity } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function UnlockYourDreamHome() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="230260" id="unlock-your-dream-home" className="relative min-h-[90vh] flex items-center bg-background text-foreground overflow-hidden border-b border-border/40">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03] dark:opacity-[0.05]" aria-hidden="true">
        <div className="h-full w-full" style={{
        backgroundImage: 'linear-gradient(to right, var(--color-border) 1px, transparent 1px), linear-gradient(to bottom, var(--color-border) 1px, transparent 1px)',
        backgroundSize: '4rem 4rem'
      }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full relative z-10 py-20 lg:py-0">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {}
          <div ref={textRef} className={`lg:col-span-7 flex flex-col justify-center transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md border border-secondary/30 bg-secondary/10 backdrop-blur-sm w-fit mb-8">
              <Activity className="size-4 text-secondary" />
              <span className="text-sm font-default font-medium text-foreground tracking-wider uppercase">Premier Mortgage Brokerage</span>
            </div>

            <h1 className="font-default text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight text-foreground leading-[1.1]">
              Unlock Your <br className="hidden sm:block" />
              <span className="text-secondary relative inline-block">
                Dream Home
                {}
                <span className="absolute -bottom-2 left-0 w-full h-1 bg-secondary/40 rounded-md"></span>
              </span>{" "}
              Today
            </h1>

            <p className="font-default font-medium text-lg sm:text-xl text-muted-foreground mt-8 max-w-2xl leading-relaxed">
              Experience the gold standard in home financing. Premier Home Loans provides expert guidance and competitive rates to help you navigate the path to homeownership with absolute confidence.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mt-10">
              <Button asChild size="lg" className="rounded-md h-14 px-8 text-base shadow-lg shadow-secondary/20 bg-secondary text-secondary-foreground hover:opacity-90">
                <Link to="/ContactPage">
                  Apply Now
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
              <Button asChild size="lg" className="rounded-md h-14 px-8 text-base shadow-lg shadow-secondary/20 bg-secondary text-secondary-foreground hover:opacity-90">
                <Link to="/LoanOptionsPage">
                  View Rates
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`lg:col-span-5 relative h-[500px] lg:h-[600px] w-full max-w-md mx-auto lg:max-w-none transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            {}
            <div className="absolute -left-6 top-1/4 bottom-1/4 w-px bg-gradient-to-b from-transparent via-secondary/30 to-transparent hidden lg:block" />
            <div className="absolute -right-6 top-1/3 bottom-1/3 w-px bg-gradient-to-b from-transparent via-secondary/30 to-transparent hidden lg:block" />
            <div className="absolute -top-6 left-1/4 right-1/4 h-px bg-gradient-to-r from-transparent via-secondary/30 to-transparent hidden lg:block" />

            {}
            <div className="relative w-full h-full rounded-tl-3xl rounded-br-3xl rounded-tr-md rounded-bl-md overflow-hidden border border-border/50 bg-primary shadow-2xl group">
              
              {}
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686228/img/modern_luxury_home_exterior.png" alt="Modern architectural home exterior representing luxury and stability" className="w-full h-full object-cover opacity-60 mix-blend-luminosity transition-transform duration-1000 group-hover:scale-105" />

              {}
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/90 via-primary/40 to-transparent pointer-events-none" />

              {}
              <style dangerouslySetInnerHTML={{
              __html: `
                @keyframes scanline {
                  0% { transform: translateY(-100%); opacity: 0; }
                  10% { opacity: 1; }
                  90% { opacity: 1; }
                  100% { transform: translateY(1000%); opacity: 0; }
                }
                .animate-scanline {
                  animation: scanline 4s linear infinite;
                }
              `
            }} />
              <div className="absolute top-0 left-0 w-full h-[2px] bg-secondary animate-scanline pointer-events-none" />
              
              {}
              <div className="absolute bottom-8 right-8 flex gap-2">
                <div className="size-1.5 rounded-md bg-secondary animate-pulse" />
                <div className="size-1.5 rounded-md bg-secondary/50" />
                <div className="size-1.5 rounded-md bg-secondary/30" />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}